import axios from "axios";

export default {
    data() {
        return {
            processExport: false
        }
    },
    methods: {
        getExportPositionIds() {
            const table = this.$refs.positionsTable;
            const positions = Array.isArray(table?.filteredPositions)
                ? table.filteredPositions
                : (Array.isArray(this.positions) ? this.positions : []);

            return positions
                .map(position => Number(position?.id))
                .filter(id => Number.isInteger(id) && id > 0);
        },
        async exportExcel() {
            this.processExport = true;
            this.serverError = null;
            this.successMessage = null;

            const positionIds = this.getExportPositionIds();
            const formDataToSubmit = new FormData();
            formDataToSubmit.append('position_ids', JSON.stringify(positionIds));

            try {
                if (!positionIds.length) {
                    throw new Error('No positions for export');
                }

                let url = `/api/order/export/`;

                const response = await axios.post(url, formDataToSubmit,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                if (response.data.status == 'error') {
                    this.serverError= '';
                    for (let i in response.data.errors) {
                        console.log(typeof response.data.errors[i].code)
                        if (typeof response.data.errors[i].code == 'number') {
                            this.serverError = this.t('errors.serverError');
                            break;
                        }
                        else
                            this.serverError += response.data.errors[i].message+"<br>";
                    }
                    throw new Error(this.serverError);
                }
                else {
                    window.open(response.data.data, '_blank');
                    if (typeof this.addNotify === 'function') {
                        this.addNotify({text: this.t('orderPage.notify.exportSuccess')});
                    }
                }

            } catch (error) {
                this.serverError = error;
            } finally {
                this.processExport = false;
            }
        },
        async handlePositionsImported(data) {
            if (Array.isArray(data?.positions) && data.positions.length && this.$refs.positionsTable) {
                await this.$refs.positionsTable.applyServerPositions(data.positions);
            }
            this.showDates = false;
        },
    }
}
